// Everything the public Misfits page shows lives here, so updating the page means editing this
// file (and dropping images into public/misfits/) rather than touching the components.

export const STEAM_URL: string | null = null; // set once the store page exists

export const TAGLINE = "A top-down auto-battler survival game where the heroes are toys.";

export const PITCH =
    "Teddy bears, army men and balloon dogs defend a bedroom floor against mutated creatures. " +
    "Play solo or with two to four friends on one screen, pick a build, and survive twenty rounds.";

export const PILLARS = [
    { title: "Deep stat builds", body: "Many interacting stats and many viable builds. Every run is a different toy box." },
    { title: "Toys with a catch", body: "Weapon-locked characters get a compensating mechanic, never just a stat downgrade." },
    { title: "Co-op from the start", body: "Two to four players on one machine, with per-player gold and gifting. Steam Remote Play Together works too." },
];

export type MediaItem = { src: string; alt: string; kind: "image" | "video"; poster?: string };

/** Files under public/misfits/. */
export const MEDIA: MediaItem[] = [
    { src: "/misfits/clip-duo1.mp4", poster: "/misfits/clip-duo1-poster.jpg", alt: "Teddy and Sarge each holding their side of the road playmat while blue block monsters close in", kind: "video" },
    { src: "/misfits/character-select.jpg", alt: "Character select with the six playable toys", kind: "image" },
    { src: "/misfits/fight-duo.jpg", alt: "Teddy and Sarge fighting side by side on the road playmat", kind: "image" },
    { src: "/misfits/clip-solo.mp4", poster: "/misfits/clip-solo-poster.jpg", alt: "Crayon playing solo and shooting down blue block monsters on the road playmat", kind: "video" },
    { src: "/misfits/arena-hud-4p.jpg", alt: "Teddy, Sarge, Doggie and Crayon playing together on the road map", kind: "image" },
    { src: "/misfits/shop-solo.jpg", alt: "Teddy browsing a wave one shop offer", kind: "image" },
    { src: "/misfits/clip-duo2.mp4", poster: "/misfits/clip-duo2-poster.jpg", alt: "Doggie and Matroschka defending the road playmat together", kind: "video" },
    { src: "/misfits/fight-solo.jpg", alt: "Crayon surrounded by blue block monsters mid-wave", kind: "image" },
    { src: "/misfits/level-up-solo.jpg", alt: "Teddy choosing an armor upgrade", kind: "image" },
    { src: "/misfits/map-select.jpg", alt: "The painted road playmat selected as the Background map", kind: "image" },
    { src: "/misfits/weapon-select.jpg", alt: "Teddy choosing a starting weapon", kind: "image" },
];

export type DevlogEntry = { date: string; title: string; points: string[] };

export const DEVLOG: DevlogEntry[] = [
    {
        date: "2026-09-29",
        title: "Toy-chest look",
        points: [
            "A warm wood palette replaces the old purple UI.",
            "Toy-block buttons and one consistent honey highlight across every screen.",
            "Bigger on-control hints in the shop, level-up and crate screens.",
        ],
    },
    {
        date: "2026-09-28",
        title: "Run history, practice and elites",
        points: [
            "Run history for your last 20 runs, plus a practice arena with respawning dummies.",
            "Elite waves with a guaranteed crate, and hordes on the easier difficulties.",
            "A fleeing piggy bank and the \"Under the bed\" mid-wave event.",
        ],
    },
    {
        date: "2026-09-28",
        title: "Bans and damage breakdown",
        points: [
            "Each player can ban up to ten items from their own shop.",
            "The game-over screen splits damage by weapon, ability, consumable and status, per player.",
        ],
    },
];
